import React from 'react';
import styled from '@emotion/styled';
import { UserType } from 'graphql-ts-types';
import type { SpaceProps } from 'styled-system';
import { themeGet } from 'styled-system';

import { useLocalization } from '../providers/LocaleProvider';
import { focusOutlineCSSWithOffset } from '../theme/styles';
import { linkStyles } from './Link';
import { BodyRegularBR2 } from './Typography';

const Disclaimer = styled(BodyRegularBR2)<any>`
  a {
    ${linkStyles};
    ${focusOutlineCSSWithOffset};
    border-radius: ${themeGet('radii.small')};
    color: ${themeGet('colors.sys.neutral.text.strong')};
    text-decoration: underline;
  }
`;

interface RegistrationDisclaimerProps extends SpaceProps {
  userType?: UserType;
}

const RegistrationDisclaimer = ({
  userType = UserType.Private,
  ...spaceProps
}: RegistrationDisclaimerProps) => {
  const { r, t, prefix } = useLocalization();

  return (
    <Disclaimer
      as="p"
      mb="sp_0"
      textAlign="left"
      whiteSpace="pre-line"
      mt={['sp_20', null, 'sp_24', 'sp_32']}
      dangerouslySetInnerHTML={{
        __html: r.t('h24_registration_page_disclaimer', {
          agb_href: prefix(
            t(userType === UserType.Business ? 'h24_agb_link_url_b2b' : 'h24_agb_link_url')
          ),
          datenschutz_href: prefix(t('h24_datenschutz_link_url')),
        }),
      }}
      {...spaceProps}
    />
  );
};

export default RegistrationDisclaimer;
